// extracted by mini-css-extract-plugin
module.exports = {"bubble":"DealerLogo_bubble__CK2DN","noImage":"DealerLogo_noImage__jk0E4"};